module.exports = __webpack_public_path__ + "img/tips-pdf.7323b66d.svg";